import { render, staticRenderFns } from "./Vantaggi.vue?vue&type=template&id=3fd4fdea&scoped=true"
import script from "./Vantaggi.vue?vue&type=script&lang=js"
export * from "./Vantaggi.vue?vue&type=script&lang=js"
import style0 from "./Vantaggi.vue?vue&type=style&index=0&id=3fd4fdea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd4fdea",
  null
  
)

export default component.exports